import { useApiFilterSuggestions } from './useApiFilterSuggestions';
import useFilterSuggestions from './useFilterSuggestions';

interface UseSuggestionsSourceOptions {
  useApiSuggestions?: boolean;
}

export const useSuggestionsSource = (
  filterName: string,
  { useApiSuggestions = false }: UseSuggestionsSourceOptions = {},
) => {
  const lookerSuggestions = useFilterSuggestions(filterName, { enabled: !useApiSuggestions });
  const apiSuggestions = useApiFilterSuggestions({ filterName, enabled: useApiSuggestions });

  return useApiSuggestions ? apiSuggestions : lookerSuggestions;
};
